import React from "react";

const PricingTable = () => {
  return (
    <div className="pricing-container">
      <div className="plan basic-plan">
        <div className="plan-header">
          <span className="icon">🔒</span>
          <h3>Basic Plan</h3>
          <p className="mt-3 desc">All-In-One: Repair your own credit using AI</p>
        </div>
        <ul className="plan-features">
          <li>Repair Credit using AI (One-Click)</li>
          <li>Boost & Increase Credit Score</li>
          <li>Monitor Credit Score Performance</li>
          <li>Dispute Negative Accounts</li>
          <li>Dispute Late Payments</li>
          <li>Dispute Collections</li>
          <li>Dispute Charge Offs</li>
          <li>Dispute Bankruptcy</li>
          <li>Dispute Repossessions</li>
          <li>Dispute Medical Bills</li>
          <li>Dispute Evictions</li>
          <li>Dispute Foreclosures</li>
          <li>Dispute Student Loans</li>
          <li>Dispute Child Support</li>
          <li>Dispute Judgments</li>
          <li>And More</li>
        </ul>
        <div className="btn">$149/Month</div>
      </div>

      <div className="plan diamond-plan">
        <div className="plan-header">
          <span className="icon">💎</span>
          <h3>Exclusive Diamond+</h3>
          <p className="mt-3 desc">Your Exclusive VIP Pass to Wealth Building.</p>
        </div>
        <ul className="plan-features">
          <li>Everything In Basic Plan</li>
          <li>24/7 Dedicated Credit Repair Specialist</li>
          <li>Done for You Credit Repair</li>
          <li>Done for You Funding</li>
          <li>Access Funding Portal</li>
          <li>Access Invest Portal</li>
          <li>Unlimited Consultations</li>
          <li>Combine Funds & Invest with Investors</li>
          <li>Access Real Estate Guides</li>
          <li>Access Business Acquisition Guides</li>
          <li>Access Investors Only VIP Room</li>
        </ul>
        <div className="btn">$499/One-Time</div>
        <div className="most-popular">Most Popular</div>
      </div>
    </div>
  );
};

export default PricingTable;
